import { Route } from '@angular/router';
import { signInGuard } from '@client/auth/guards/auth.guards';

export const SIGN_IN_ROUTE: Route = {
    path: 'sign-in',
    canActivate: [signInGuard],
    loadComponent: () => import('@client/auth/components/sign-in-page/sign-in-page').then((m) => m.SignInPage),
};
